<ng-template #template>
  <span class="spg-color-editor__color-swatch" [style]="getStyle()"></span>
  <sv-ng-string [model]="model.locTitle"></sv-ng-string>
</ng-template>